import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import WhitePassport from "../images/ESN black_passport.png";
import { getProfile } from "../../core/store/actions/auth";
import "../../styles/messagePage.css";
import { Icon } from '@iconify/react/dist/iconify.js';
import { useAuth } from '../../core/AuthContext'; // Import the useAuth hook
import { logoutUser } from '../../core/store/actions/auth';
import { hasPlatformAccess, isFormerMember } from '../../core/utils/permissionUtils';
import { ROUTE_PATHS } from '../../core/routes';

function WaitingForHR() {
    const dispatch = useDispatch();
    const history = useHistory();

    useAuth();

    const user = useSelector((state) => state.user);

    const handleRefresh = () => {
        dispatch(getProfile());
    };

    const handleLogout = () => {
        dispatch(logoutUser());
        history.push("/main");
      };

    useEffect(() => {
        if (hasPlatformAccess(user?.profile)) {
            history.push("/main");
            return;
        }
        if (isFormerMember(user?.profile)) {
            history.push(ROUTE_PATHS.platformAccessRevoked);
        }
    }, [user, history]);

    return (
        <div className="error-message-container">
            <h3 className="error-message-title">Now it's our turn!</h3>
            <img src={WhitePassport} alt="Black Passport" className="error-image"></img>
            <p className="error-message">
                Your passport is being processed by our amazing HR Team. Soon you'll be granted access
                to this platform, so stay tuned! <br/>
                In the meantime, validate your email address(es) by clicking the link(s) we sent you. If you haven't received any email, please check your spam folder or contact the IT manager.
            </p>
            <button className="button" style={{ marginTop: '20px' }} onClick={handleRefresh}>
                Refresh
            </button>

            <button style={{border:"none", background:"none", display:"flex", flexDirection:"row", alignContent:"center", margin:"10px"}} onClick={handleLogout}>
              <Icon icon="fluent:arrow-exit-20-filled" width="1.5em" height="1.5em" style={{ marginRight: '10px' }} />
              Log Out
            </button>
        </div>
    );
}

export default WaitingForHR;
